import styled from '@emotion/styled';

import { BannerSection } from 'src/types/subscription';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { getSubsImageUrl } from 'src/utils/SubscriptionHelper/SubscriptionHelper';

import { useAppStore } from '../../../hooks/useAppStore';

const ImageContainer = styled.img`
  width: 100%;
  border-radius: 8px;
`;

const getImageSrc = (data?: BannerSection | null, deviceWidth = 768) => {
  if (!data?.images?.length) return null;
  return getSubsImageUrl(deviceWidth, TAG_NAME.SUBS_OFFER, data.images[0]);
};

const OffersCard = ({ data }: { data?: BannerSection | null }) => {
  const { appConfig = {} } = useAppStore();
  const { deviceWidth = 768 } = appConfig;
  const imageSrc = getImageSrc(data, deviceWidth);
  if (!imageSrc) return null;
  return (
    <ImageContainer data-test-id="offer-banner-container" src={imageSrc} />
  );
};

export default OffersCard;
